import { makeStyles, TextField } from '@material-ui/core';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

const useStyles = makeStyles({
  textField: {
    marginRight: '10px',
  },
});

/*

i tried to use type=number here but it's just buggy when you set value.  for now this is just a simple input that updates the parent state on blur only

*/

const HoursInput = ({ setValue, limitHours, value, ...props }) => {
  const classes = useStyles();
  const [localValue, setLocalValue] = useState(null);
  useEffect(() => {
    if (Number.parseFloat(value) != Number.parseFloat(localValue))
      setLocalValue(Number.parseFloat(value).toFixed(2));
  }, [value]);
  const handleFocus = (event) => event.target.select();
  const onChange = (event) => {
    setLocalValue(event.target.value);
    const value =
      event.target.value != '' ? Number.parseFloat(event.target.value) : undefined;
    if (
      value &&
      ((limitHours && ((value >= -24 && value < 24) || !value)) || !limitHours)
    )
      setValue(value);
  };
  const onBlur = (event) => {
    const value =
      event.target.value != ''
        ? Number.parseFloat(Number.parseFloat(event.target.value).toFixed(2))
        : 0;
    if (value != props.value) setValue(value);
    setLocalValue(Number.parseFloat(value).toFixed(2));
  };
  const restrictInput = (event) => {
    var e = event || window.event; // get event object
    var key = e.keyCode || e.which; // get key cross-browser
    if (
      !(
        key < 32 ||
        key > 126 ||
        key == 45 ||
        key == 46 ||
        (key > 47 && key < 58) ||
        (key > 95 && key < 106) ||
        key == 110
      )
    ) {
      if (e.preventDefault) e.preventDefault(); //normal browsers
      e.returnValue = false; //IE
    }
  };
  return (
    <TextField
      {...props}
      type="number"
      step=".01"
      onFocus={handleFocus}
      className={classes.textField}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={restrictInput}
      value={localValue || ''}
    />
  );
};

export default HoursInput;
